<script lang="ts" setup>
    import { computed } from 'vue'
    import { storeToRefs } from 'pinia'
    import { DateTime } from 'luxon'
    import { useLogStore } from '~~/stores/log'

    const logStore = useLogStore()
    const { entries } = storeToRefs(logStore)

    const sortedEntries = computed(
        () => entries.value.toSorted(
            (a, b) => b.timestamp - a.timestamp,
        ),
    )
</script>

<template>
    <q-list>
        <q-item
            v-for="entry in sortedEntries"
            :class="entry.type"
            dense
        >
            <q-item-section>
                <q-item-label>{{ entry.message }}</q-item-label>
                <q-item-label caption v-for="item in entry.items">
                    {{ item }}
                </q-item-label>
                <q-item-label caption class="timestamp">
                    {{ entry.timestamp.toLocaleString(DateTime.TIME_WITH_SECONDS) }}
                </q-item-label>
            </q-item-section>
        </q-item>
    </q-list>
</template>

<style lang="scss" scoped>
    .q-item {
        border-bottom: 1px solid gainsboro;

        &.info {
            opacity: 0.7;
        }

        &.error {
            background-color: $red;
        }
    }

    .timestamp {
        text-align: right;
    }
</style>
